module.exports = __webpack_public_path__ + "img/8.3c3c58c1.jpg";